import { useState, useRef } from "react";
import { AddGroupBy } from "../../../../services/ProductService/AllProductList/AllProductServices";

export default function AddGroupPopup({onResponse,onRemoveGroupBy}) {
    const [isOpen, setIsOpen] = useState(false);
    const popupRef = useRef(null);

    const [searchTerm1, setSearchTerm1] = useState("");
    const [searchTerm2, setSearchTerm2] = useState("");
    const [selectedOption1Key, setSelectedOption1Key] = useState("");
    const [selectedOption2Key, setSelectedOption2Key] = useState("");
    const [selectedOption3Key, setSelectedOption3Key] = useState("");
    const [selectedOption1Value, setSelectedOption1Value] = useState("");
    const [selectedOption2Value, setSelectedOption2Value] = useState("");
    const [selectedOption3Value, setSelectedOption3Value] = useState("");
    const [isDropdown1Open, setIsDropdown1Open] = useState(false);
    const [isDropdown2Open, setIsDropdown2Open] = useState(false);
    const [isDropdown3Open, setIsDropdown3Open] = useState(false);
    const [removeAddGroupBy, setRemoveAddGroupBy] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const options1 = {
        "Product Id": "p_id",
        "Status": "active",
        "Product Name": "name",
        "Product Category": "category_p",
        "Product HSN Code": "p_hsn_code_no",
        "Verified": "is_verified",
        "Product Added By": "p_add_by",
        "Product Added Date": "p_add_date",
        "Product Added Time": "p_add_time",
        "Product Last Modified By": "p_last_modified_by",
        "Product Last Modified Date": "p_last_add_date",
        "Product Last Modified Time": "p_last_add_time",
        "Product Owner": "p_owner",
        "Product Recommended for": "p_recommended_for",
        "Tags": "tag",
        "Next Step": "next_step",
        "Default Unit": "default_unit",
        "Indicative Min Price": "indicative_min_price",
        "Indicative Max Price": "indicative_max_price",
        "Product Price": "p_price",
        "Product Old Price": "p_old_price",
        "Product Discount": "p_discount",
        "Production Capacity": "production_capacity",
        "Production Capacity Unit": "production_capacity_unit",
        "Present Stock Status": "present_stock_status",
        "Production Lead Time": "production_lead_time",
        "Minimum Order Quantity": "min_order_quantity",
        "Minimum Order Quantity Unit": "min_order_quantity_unit",
        "Product Life": "p_life",
        "Product LifeSpan": "p_lifespan",
        "Product Certifications": "p_certification",
        "Product Description": "p_description",
        "Product Varients": "p_varient",
    };

    const options2 = { Count: 'count', Sum: "sum", Average: "average" }; // ✅ Fixed spelling

    const filteredOptions1 = Object.keys(options1).filter((key) =>
        key.toLowerCase().includes(searchTerm1.toLowerCase())
    );

    const filteredOptions2 = Object.keys(options2).filter((key) =>
        key.toLowerCase().includes(searchTerm2.toLowerCase())
    )

    const handleGroupBy = async () => {
        // Validation check: Ensure required fields are selected
        if (!selectedOption1Value || !selectedOption2Value) {
            setErrorMessage("All fields are required!");
            return;
        }
    
        let params = {
            field_name: selectedOption1Value,
            comparison_operator: selectedOption2Value,
        };
    
        // For "sum" and "average", an additional field is required
        if (selectedOption2Value === "sum" || selectedOption2Value === "average") {
            if (!selectedOption3Value) {
                setErrorMessage("All fields are required!");
                return;
            }
            params[selectedOption2Value === "sum" ? "sum_field" : "avg_field"] = selectedOption3Value;
        }
    
        try {
            const response = await AddGroupBy("GET", { params });
            onResponse(response.data);
            setRemoveAddGroupBy(true);
            setSelectedOption1Value('')
            setSelectedOption2Value('')
            setSelectedOption3Value('')
            setSelectedOption1Key('')
            setSelectedOption2Key('')
            setSelectedOption3Key('')
            setIsOpen(false);
            setErrorMessage(""); // Clear error on success
        } catch (error) {
            setErrorMessage("Something went wrong. Please try again.");
        }
    };    

    const handleRemoveGroupBy = () =>{
        onRemoveGroupBy(false)
        setRemoveAddGroupBy(false)
    }

    return (
        <div className="relative">
            <span className="flex items-center gap-3">
            <p
                className="group-hover:text-black cursor-pointer"
                onClick={() => setIsOpen(!isOpen)}
            >
                Add Group </p>
                {removeAddGroupBy && (<p className="px-2 py-0.5 rounded-full text-gray-500 bg-white w-fit flex " 
                onClick={handleRemoveGroupBy}>X</p>)}
                </span>
            {isOpen && (
                <div
                    ref={popupRef}
                    className="absolute top-12 -left-[400px] bg-white shadow-lg border border-gray-300 rounded-lg py-4 px-6 w-fit"
                >
                    <div className="flex flex-col gap-2">
                        <div className="flex gap-2">
                            {/* First Dropdown */}
                            <div className="w-60 relative">
                                <input
                                    type="text"
                                    placeholder="Select"
                                    className="border border-gray-400 bg-gray-200 text-gray-500 rounded-lg px-3 outline-none w-full cursor-pointer"
                                    value={selectedOption1Key}
                                    readOnly
                                    onClick={() => setIsDropdown1Open(!isDropdown1Open)}
                                />
                                {isDropdown1Open && (
                                    <div className="absolute top-12 left-0 bg-white border rounded w-full shadow-lg z-10 p-3">
                                        <input
                                            type="text"
                                            placeholder="Search..."
                                            className="border border-gray-400 rounded-lg px-3 outline-none w-full cursor-pointer"
                                            value={searchTerm1}
                                            onChange={(e) => setSearchTerm1(e.target.value)}
                                        />
                                        <div className="h-60 overflow-y-scroll">
                                            {filteredOptions1.map((key) => (
                                                <p
                                                    key={key}
                                                    className="px-3 py-2 hover:bg-gray-100 cursor-pointer"
                                                    onClick={() => {
                                                        setSelectedOption1Key(key);
                                                        setSelectedOption1Value(options1[key]);
                                                        setIsDropdown1Open(false);
                                                    }}
                                                >
                                                    {key}
                                                </p>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* Second Dropdown */}
                            <div className="w-40 relative">
                                <input
                                    type="text"
                                    placeholder="Select"
                                    className="border border-gray-400 bg-gray-200 text-gray-500 rounded-lg px-3 outline-none w-full cursor-pointer"
                                    value={selectedOption2Key}
                                    readOnly
                                    onClick={() => setIsDropdown2Open(!isDropdown2Open)}
                                />
                                {isDropdown2Open && (
                                    <div className="absolute top-12 left-0 bg-white border rounded w-full shadow-lg z-10 p-3">
                                        <input
                                            type="text"
                                            placeholder="Search..."
                                            className="border border-gray-400 rounded-lg px-3 outline-none w-full cursor-pointer"
                                            value={searchTerm2}
                                            onChange={(e) => setSearchTerm2(e.target.value)}
                                        />
                                        {filteredOptions2.map((key) => (
                                            <p
                                                key={key}
                                                className="px-3 py-2 hover:bg-gray-100 cursor-pointer"
                                                onClick={() => {
                                                    setSelectedOption2Key(key); // ✅ Store value, not key
                                                    setSelectedOption2Value(options2[key]);
                                                    setIsDropdown2Open(false);
                                                }}
                                            >
                                                {key} {/* ✅ Show values instead of keys */}
                                            </p>
                                        ))}
                                    </div>
                                )}
                            </div>
                            {/* Third Dropdown */}
                            {selectedOption2Key !== "Count" && selectedOption2Key !== "" && (
                                <div className="w-60 relative">
                                    <input
                                        type="text"
                                        placeholder="Select"
                                        className="border border-gray-400 bg-gray-200 text-gray-500 rounded-lg px-3 outline-none w-full cursor-pointer"
                                        value={selectedOption3Key}
                                        readOnly
                                        onClick={() => setIsDropdown3Open(!isDropdown3Open)}
                                    />
                                    {isDropdown3Open && (
                                        <div className="absolute top-12 left-0 bg-white border rounded w-full shadow-lg z-10 p-3">
                                            <input
                                                type="text"
                                                placeholder="Search..."
                                                className="border border-gray-400 rounded-lg px-3 outline-none w-full cursor-pointer"
                                                value={searchTerm1}
                                                onChange={(e) => setSearchTerm1(e.target.value)}
                                            />
                                            <div className="h-60 overflow-y-scroll">
                                                {filteredOptions1.map((key) => (
                                                    <p
                                                        key={key}
                                                        className="px-3 py-2 hover:bg-gray-100 cursor-pointer"
                                                        onClick={() => {
                                                            setSelectedOption3Key(key);
                                                            setSelectedOption3Value(options1[key]);
                                                            setIsDropdown3Open(false);
                                                        }}
                                                    >
                                                        {key}
                                                    </p>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                        {errorMessage && <p className="text-red-500 text-sm">{errorMessage}</p>}
                        <div className="flex justify-end mx-5 my-2">
                            <button className="bg-sky-500 px-3 py-2 rounded-lg text-white cursor-pointer w-fit" onClick={handleGroupBy}>Submit</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}